import type { ChildrenWrapperProps } from "@circle-react-uikit/Form/Item";

export const ChildrenWrapper = ({ children }: ChildrenWrapperProps) => (
  <div className="w-full">{children}</div>
);
